module.exports = __webpack_public_path__ + "04_mole.5a929e68.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer2/04_mole.png
// module id = pOkf
// module chunks = 0